"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseEntity = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BaseEntity = /*#__PURE__*/function () {
  function BaseEntity() {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, BaseEntity);

    this.context = context;
  }

  _createClass(BaseEntity, [{
    key: "getOption",
    value: function getOption(name) {
      var _this$options$name;

      return (_this$options$name = this.options[name]) !== null && _this$options$name !== void 0 ? _this$options$name : null;
    }
  }, {
    key: "getRequiredOption",
    value: function getRequiredOption(name) {
      var option = this.options[name];

      if (_lodash.default.isNil(option)) {
        throw new Error("'".concat(name, "' is not defined."));
      }

      return option;
    }
  }, {
    key: "options",
    get: function get() {
      var _this$context$options;

      return (_this$context$options = this.context.options) !== null && _this$context$options !== void 0 ? _this$context$options : {};
    }
  }, {
    key: "engineOptions",
    get: function get() {
      var _this$context$engineO;

      return (_this$context$engineO = this.context.engineOptions) !== null && _this$context$engineO !== void 0 ? _this$context$engineO : {};
    }
  }, {
    key: "targetComponentInstance",
    get: function get() {
      return this.getRequiredOption('targetComponentInstance');
    }
  }, {
    key: "sourceComponentInstance",
    get: function get() {
      return this.getRequiredOption('sourceComponentInstance');
    }
  }, {
    key: "formInstance",
    get: function get() {
      return this.getRequiredOption('formInstance');
    }
  }], [{
    key: "name",
    get: function get() {
      throw new Error('Getter #name() is abstract.');
    }
  }, {
    key: "title",
    get: function get() {
      throw new Error('Getter #title() is abstract.');
    }
  }]);

  return BaseEntity;
}();

exports.BaseEntity = BaseEntity;